// data-testid constants
export const HOME = {
  emergentLink: "home-emergent-link",
};

export const NAV = {
  logo: "nav-logo",
  linkHome: "nav-link-home",
  linkAbout: "nav-link-about",
  linkServices: "nav-link-services",
  linkWork: "nav-link-work",
  linkContact: "nav-link-contact",
  ctaTalk: "nav-cta-talk",
};

export const HERO = {
  primaryCta: "hero-primary-cta",
  secondaryCta: "hero-secondary-cta",
  portrait: "hero-portrait",
};

export const SERVICES = {
  section: "services-section",
  card: (slug) => `service-card-${slug}`,
};

export const PORTFOLIO = {
  section: "portfolio-section",
  card: (slug) => `portfolio-card-${slug}`,
};

export const TESTIMONIALS = {
  section: "testimonials-section",
};

export const CONTACT = {
  section: "contact-section",
  emailLink: "contact-email-link",
  phoneLink: "contact-phone-link",
  socialLinkedin: "contact-linkedin",
  socialInstagram: "contact-instagram",
  socialTwitter: "contact-twitter",
};

export const CHAT = {
  trigger: "ai-chat-trigger",
  dialog: "ai-chat-dialog",
  input: "ai-chat-input",
  send: "ai-chat-send",
  messages: "ai-chat-messages",
  close: "ai-chat-close",
};
